<template>
  <div id="app">
    <div v-if="!!weekData" class="live_title">
      <span >{{ weekData.weekName }}直播安排</span>
      <span
        >( {{ titleDateDeal(weekData.beginDate, 1) }} -
        {{ titleDateDeal(weekData.endDate) }} )</span
      >
    </div>
    <div v-if="liveList.length !== 0">
      <el-card
        v-for="item in liveList"
        :key="item.lessonId"
        class="card_list couser"
        :body-style="{ padding: '0px' }"
        shadow="never"
      >
        <div
          @click="liveClick(item.lessonId)"
        >
          <el-row>
            <el-col :span="3" style="height: 1px;">
              <div class="centent_left">
                <img
                  v-if="item.liveStatus == 1"
                  class="img_centent"
                  height="120"
                  src="../../assets/img/red.png"
                  alt=""
                />
                <img
                  v-else
                  class="img_centent"
                  height="120"
                  src="../../assets/img/gray.png"
                  alt=""
                />
                <div class="centent_time" :class="{centent_time_e:item.liveStatus != 1}">
                  <div class="centent_time_when">
                    {{ timeDeal(item.beginTime) }} -
                    {{ timeDeal(item.endTime) }}
                  </div>
                  <span class="centent_time_date">
                    {{ dataDeal(item.beginTime) }}
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :span="16">
              <div>
                <div class="centent_title">
                  {{ item.courseName }}
                </div>
                <div class="centent_school">
                  <span>{{ item.schoolName }}</span>
                  <span>{{ item.courseSpeaker || '' }}</span>
                </div>
              </div>
            </el-col>
            <el-col class="centent_right" :span="5">
              <div class="right_num">
                <span
                  class="right_num_img"
                  ><img
                    style="vertical-align: sub"
                    width="18px"
                    src="../../assets/img/guankan.png"
                  />{{ item.lessonViewnum }}</span
                >
                <span>
                  <img
                    style="vertical-align: sub"
                    width="18px"
                    src="../../assets/img/dianzan.png"
                  />{{ item.lessonZannum }}
                </span>
              </div>

              <div style="display: inline-block">
                <span
                  v-if="item.liveStatus == 4"
                  @click="liveClick(item.lessonId)"
                  class="centent_btn"
                  >查看回放</span
                >
                <span style="color: #999999" v-if="item.liveStatus == 3"
                  >直播已结束</span
                >
                <span style="color: #999999" v-if="item.liveStatus == 2"
                  >直播未开始</span
                >
                <div
                  class="live_new"
                  style="color: #ff6d4e"
                  v-if="item.liveStatus == 1"
                >
                  <span>正在直播</span>
                  <span class="right_box1"></span>
                  <span class="right_box2"></span>
                  <span class="right_box3"></span>
                  <span class="right_box4"></span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div style="text-align: center" v-else>
      <img
        style="margin-top: 200px"
        width="200"
        src="../../assets/img/livelist.png"
      />
    </div>
  </div>
</template>
<script>
import {
  usercenterinfo,
  lessonOnList,
  PcQuitUpate,
  getCurrentWeek,
} from "@/api/home";
export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      groupId: 1,
      curPage: 1,
      pageSize: 10,
      courseTypeid: 1,
      roomTypes: 3,
      totalCount: 0,
      liveList: [],
      timer: null,
      weekData: null,
    };
  },
  created() {
    if (!!this.token) {
      this.usercenterinfo();
    } else {
      this.getCurrentWeek();
    }
  },
  methods: {
    // 获取当前周次
    getCurrentWeek() {
      getCurrentWeek().then((res) => {
        let data = res.data.data
        if (!data) {
          this.weekData = null
          return false
        }
        this.weekData = data;
        this.lessonOnList();
      });
    },
    //   获取用户信息
    usercenterinfo() {
      usercenterinfo().then((res) => {
        console.log(res);
        if (!res) {
          localStorage.clear()
          this.getCurrentWeek();
          return false
        }
        this.groupId = res.data.data.groupId;
        this.getCurrentWeek();
      });
    },
    //   获取直播列表
    lessonOnList() {
      let params = {
        groupId: this.groupId,
        curPage: this.curPage,
        pageSize: this.pageSize,
        courseTypeid: this.courseTypeid,
        roomTypes: this.roomTypes,
        courseState:1,
        beginDate: this.weekData.beginDate,
        endDate: this.weekData.endDate,
      };
      lessonOnList(params).then((res) => {
        this.liveList = res.data.data.dataList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    // 时间处理
    timeDeal(str) {
      let idx = str.indexOf(" ");
      let dealStr = str.slice(idx, 16);
      return dealStr;
    },
    // 日期处理
    dataDeal(str) {
      let weeks = new Date(str).getDay();
      let month = new Date(str).getMonth() + 1;
      let day = new Date(str).getDate();
      let week;
      switch (weeks) {
        case 1:
          week = "周一";
          break;
        case 2:
          week = "周二";
          break;
        case 3:
          week = "周三";
          break;
        case 4:
          week = "周四";
          break;
        case 5:
          week = "周五";
          break;
        case 6:
          week = "周六";
          break;
        case 0:
          week = "周日";
          break;
        default:
          break;
      }
      let dealStr = month + "月" + day + "日" + week;
      return dealStr;
    },
    titleDateDeal(str, flag = 2) {
      let date = "";
      let month = new Date(str).getMonth() + 1;
      let day = new Date(str).getDate();
      let year = new Date(str).getFullYear();
      if (flag == 1) {
        date = year + "年" + month + "月" + day + "日";
      } else {
        date = month + "月" + day + "日";
      }
      return date;
    },
    // 点击进入 直播间
    liveClick(id) {
      let routeData = this.$router.resolve({
        path: "/live",
        query: { id: id },
      });
      window.open(routeData.href, "_blank");
    },
    // 更新直播退出状态
    pcQuitUpates(id) {
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      let params = {
        ip: ip,
        lessonId: id,
      };

      PcQuitUpate(params).then((res) => {
        localStorage.removeItem("lessonId");
      });
    },
  },
  beforeDestroy() {
    // 离开页面清除定时器 防止错乱
    clearInterval(this.timer);
  },
  mounted() {
    let that = this;
    window.addEventListener("storage", function (e) {
      let flag = localStorage.getItem("lessonId");
      if (flag) {
        that.pcQuitUpates(flag);
      }
    });
    that.timer = setInterval(() => {
      that.lessonOnList();
    }, 300000);
  },
};
</script>
<style scoped>
#app {
  max-width: 1440px;
  margin: 53px auto;
}
.live_title {
  text-align: center;
  margin-bottom: 20px;
}
.live_title span {
  font-size: 18px !important;
  color: #333333;
}
.card_list {
  background-color: #eee;
  height: 120px;
  margin-bottom: 15px;
  position: relative;
}
.img_centent {
  position: absolute;
  top: 0px;
  left: 0px;
}
.centent_time {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #fff;
  height: 120px;
  
}
.centent_time_when {
  margin-top: 34px;
  margin-left: 9px;
  font-size: 18px !important;
}
.centent_time_date {
  display: inline-block;
  margin-top: 5px;
  margin-left: 24px;
  font-size: 14px !important;
}
.centent_title {
  margin-top: 34px;
  font-size: 16px !important;
  color: #333333;
}
.centent_school {
  margin-top: 8px;
}
.centent_school span {
  font-size: 14px !important;
  color: #999999;
  margin-right: 10px;
}
.centent_btn {
  padding: 5px 10px;
  border: 1px solid #ff6d4e;
  background-color: #ffebe6;
  color: #ff6d4e;
  border-radius: 15px;
  cursor: pointer;
}
.centent_right {
  height: 120px;
  display: flex;
  align-items: center;
}
.right_num {
  color: #ababab;
  display: flex;
  justify-content: space-around;
  padding: 0 10px;
  box-sizing: border-box;
  width: 140px;
  margin-right: 30px;
}
.right_num_img {
  margin-right: 30px;
}
.live_new {
  position: relative;
}
.right_box1 {
  position: absolute;
  bottom: 0;
  right: -12px;
  display: inline-block;
  width: 3px;
  height: 10px;
  background: #ff6d4e;
  border-radius: 2px;
  animation: box1 1s infinite;
  /*Safari 和 Chrome:*/
  -webkit-animation: box1 1s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}

@keyframes box1 {
  from {
    height: 10px;
  }
  to {
    height: 20px;
  }
}
.right_box2 {
  position: absolute;
  bottom: 0;
  right: -18px;
  display: inline-block;
  width: 3px;
  height: 20px;
  background: #ff6d4e;
  border-radius: 2px;
  animation: box2 1s infinite;
  /*Safari 和 Chrome:*/
  -webkit-animation: box2 1s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
@keyframes box2 {
  from {
    height: 20px;
  }
  to {
    height: 10px;
  }
}
.right_box3 {
  position: absolute;
  bottom: 0;
  right: -24px;
  display: inline-block;
  width: 3px;
  height: 10px;
  background: #ff6d4e;
  border-radius: 2px;
  animation: box3 1s infinite;
  /*Safari 和 Chrome:*/
  -webkit-animation: box3 1s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}

@keyframes box3 {
  from {
    height: 10px;
  }
  to {
    height: 20px;
  }
}

.right_box4 {
  position: absolute;
  bottom: 0;
  right: -30px;
  display: inline-block;
  width: 3px;
  height: 20px;
  background: #ff6d4e;
  border-radius: 2px;
  animation: box4 1s infinite;
  /*Safari 和 Chrome:*/
  -webkit-animation: box4 1s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
@keyframes box4 {
  from {
    height: 20px;
  }
  to {
    height: 10px;
  }
}
.couser {
  cursor: pointer;
}
.centent_time_e {
  color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/index/liveList.vue